/**
 * 报表相关操作
 */
import * as ACTION from '../constants/types/reportTypes';
import { packageReq } from '../helpers/request';
import { packageObsoleteReq } from '../deconstructionCenter/obsoleteApi'


// 获取团队日结
export function getTeamHistory(startDate, endDate, username = '', pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_TEAM_HISTORY', [startDate, endDate, username, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_HISTORY,
		dirtyPayload
	}
};

// 获取个人日工资
export function getPersonalDailyWage(starttime, endtime, pstatus, pageNo, orderBy = 'create_time', sort = 'desc') {

	var dirtyPayload = packageObsoleteReq('GET_PERSONAL_DAILY_WAGE', [starttime, endtime, pstatus, pageNo, orderBy, sort], null, 'GET', true);

	return {
		type: ACTION.GET_PERSONAL_DAILY_WAGE,
		dirtyPayload
	}

}

// 获取个人账变记录
export function getPersonalSelfbankRecord(ordertypy, status, starttime, endtime, pageNo, userid) {

	var dirtyPayload = packageObsoleteReq('GET_PERSONAL_SELFBANK_RECORD', [ordertypy, status, starttime, endtime, pageNo, userid], null, 'GET', true);

	return {
		type: ACTION.GET_PERSONAL_SELFBANK_RECORD,
		dirtyPayload
	}

}


/**
 * [getTeamUserList 获取团队首页数据]
 * @author ammo 2018-05-14
 * @param  {[type]} bankMin  [用户余额左区间]
 * @param  {[type]} bankMax  [用户余额右区间]
 * @param  {[type]} username [用户名]
 * @param  {[type]} userId   [用户id]
 * @param  {[type]} pageNo   [分页]
 * @param  {[type]} orderBy  [按需排序]
 * @param  {String} sort     [正序反序]
 * @return {[type]}          [description]
 */
export function getTeamUserList(bankMin, bankMax, username, userId, pageNo, orderBy, sort = 'desc') {

	var dirtyPayload = packageObsoleteReq('GET_TEAM_USER_LIST', [bankMin, bankMax, username, userId, pageNo, orderBy, sort], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_USER_LIST,
		dirtyPayload
	}

}

/**
 * 获取推广链接
 */
export function getAgentRegisterUrL() {

	var dirtyPayload = packageObsoleteReq('AGENT_REG_URL', null, null, 'GET', true);

	return {
		type: ACTION.GET_AGENT_REG_URL,
		dirtyPayload
	}

}


/**
 * 生成推广链接
 * @author ammo 2018-05-14
 * @return {[type]} [description]
 */
export function makeAgentRegisterUrl(request) {

	var dirtyPayload = packageObsoleteReq('AGENT_REG_URL', null, request, 'POST', true);

	return {
		type: ACTION.MAKE_AGENT_REG_URL,
		dirtyPayload
	}

}

/**
 * 获取下级返点
 * @author ammo 2018-05-14
 * @param  {[type]} userId [description]
 * @return {[type]}        [description]
 */
export function getFollowerRebet(userId, callback) {

	var dirtyPayload = packageObsoleteReq('GET_FOLLOWER_REBET', [userId], null, 'GET', true);

	return {
		type: ACTION.GET_FOLLOWER_REBET,
		dirtyPayload,
		callback
	}

}

/**
 * 设置下级返点
 * @author ammo 2018-05-15
 * @param  {[type]} keepPoint [返点]
 * @param  {[type]} lotterys  [彩种]
 * @param  {[type]} point     [返点]
 * @param  {[type]} userId    [用户id]
 */
export function setFollwerRebet(keepPoint, lotterys, point, userId, callback) {

	const payloadData = {
		flag: 'rapid',
		keepoint: keepPoint,
		lottery: lotterys,
		point: point,
		uid: userId
	}

	var dirtyPayload = packageObsoleteReq('SET_FOLLOWER_REBET', null, payloadData, 'POST', true);

	return {
		type: ACTION.SET_FOLLOWER_REBET,
		dirtyPayload,
		callback
	}

}

/**
 * 获取团队下级日工资
 * @author ammo 2018-05-14
 * @param  {[type]} username  [用户名]
 * @param  {[type]} starttime [开始日期]
 * @param  {[type]} endtime   [结束日期]
 * @param  {[type]} status    [状态]
 * @param  {[type]} pageNo    [分页]
 * @param  {String} orderby   [description]
 * @param  {String} sort      [description]
 * @return {[type]}           [description]
 */
export function getTeamSalary(username, starttime, endtime, status, pageNo, orderby = 'create_time', sort = 'desc') {

	var dirtyPayload = packageObsoleteReq('GET_TEAM_SALARY', [username, starttime, endtime, status, pageNo, orderby, sort], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_SALARY,
		dirtyPayload
	}

}

/**
 * 修改密码，包括登录密码和提款密码
 * @author ammo 2018-05-14
 * @param  {[type]} request [description]
 * @return {[type]}         [description]
 */
export function changePassword(request) {



}


/*
 * [checkUsernameForRegister 代理注册下级用户，检查用户名可用]
 * @author ammo 2018-05-12
 * @param  {[type]} username [description]
 * @return {[type]}          [description]
 */
export function checkUsernameForRegister(username) {
	var dirtyPayload = packageObsoleteReq('CHECK_USERNAME_FOR_REGISTER', [username], null, 'GET', true);
	return {
		type: ACTION.CHECK_USERNAME_FOR_REGISTER,
		dirtyPayload,
	}
}


/**
 * 获取真人下级反水
 * @author ammo 2018-05-15
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} username  [description]
 * @param  {[type]} status    [description]
 * @param  {String} orderBy   [description]
 * @param  {String} sort      [description]
 * @return {[type]}           [description]
 */
export function getLiveTeamSalary(starttime, endtime, username, status, pageNo, orderBy = 'create_time', sort = 'desc') {

	var dirtyPayload = packageObsoleteReq('GET_LIVE_TEAM_SALARY', [starttime, endtime, username, status, pageNo, orderBy, sort], null, 'GET', true);

	return {
		type: ACTION.GET_LIVE_TEAM_SALARY,
		dirtyPayload,
	}

}


/**
 * 获取下级充值限额
 * @author ammo 2018-05-15
 * @param  {[type]} userId [description]
 * @param  {[type]} token  [description]
 * @return {[type]}        [description]
 */
export function getTransferLimit(userId, token) {

	var dirtyPayload = packageObsoleteReq('GET_TRANSFER_LIMIT', [userId, token], null, 'GET');

	return {
		type: ACTION.GET_TRANSFER_LIMIT,
		dirtyPayload,
	}

}

/**
 * 提交下级充值
 * @author ammo 2018-05-15
 * @param  {[type]}   userId   [description]
 * @param  {[type]}   money    [description]
 * @param  {[type]}   token    [description]
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
export function transfer2Member(userId, money, token, callback) {

	const payloadData = {
		flag: 'confirm',
		uid: userId,
		check: token,
		money: money
	}

	var dirtyPayload = packageObsoleteReq('SUBMIT_TEAM_GROUP_TRANSFER', null, payloadData, 'POST', true);

	return {
		type: ACTION.SUBMIT_TEAM_GROUP_TRANSFER,
		dirtyPayload,
		callback
	}

}

/**
 * 获取真人下级契约
 * @author ammo 2018-05-16
 * @param  {[type]} username [description]
 * @param  {[type]} status   [description]
 * @param  {[type]} pageNo   [description]
 * @return {[type]}          [description]
 */
export function getTeamCompactLive(username, status, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_TEAM_COMPACT_LIVE', [username, status, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_COMPACT_LIVE,
		dirtyPayload,
	}

}


/**
 * 查询彩票投注记录
 * @author ammo 2018-05-16
 * @param  {[type]}  starttime [description]
 * @param  {[type]}  endtime   [description]
 * @param  {[type]}  lotteryId [description]
 * @param  {[type]}  methodId  [description]
 * @param  {[type]}  username  [description]
 * @param  {Boolean} isChild   [description]
 * @return {[type]}            [description]
 */
export function getLotteryBetHis(starttime, endtime, lotteryId, methodId, username, isChild, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_LOTTERY_BET_HIS', [starttime, endtime, lotteryId, methodId, username, isChild, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_LOTTERY_BET_HIS,
		dirtyPayload,
	}

}

/**
 * [getTeamCompactDetail 真人反水，下级契约详情]
 * @author ammo 2018-05-16
 * @param  {[type]} userId [description]
 * @return {[type]} type   [description] 1 为日工资下级契约 2 为真人下契约详情
 */
export function getTeamCompactDetail(userId, type, callback) {
	var dirtyPayload = packageObsoleteReq('GET_TEAM_COMPACT_DETAIL', [userId, type], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_COMPACT_DETAIL,
		dirtyPayload,
		callback
	}

}


/**
 * 获取投注详情
 * @author ammo 2018-05-16
 * @param  {[type]} id   [description]
 * @param  {[type]} time [description]
 * @return {[type]}      [description]
 */
export function getBetDetail(id, time, issue = '') {

	var dirtyPayload = packageObsoleteReq('GET_BET_DETAIL', [id, time, issue], null, 'GET', true);

	return {
		type: ACTION.GET_BET_DETAIL,
		dirtyPayload,
	}

}


/**
 * 获取彩票报表概要信息【含盈亏】
 * @author ammo 2018-05-17
 * @param  {[type]}  startDate [description]
 * @param  {[type]}  endDate   [description]
 * @param  {[type]}  username  [description]
 * @param  {Boolean} isChild   [description]
 * @param  {[type]}  pageNo    [description]
 * @param  {String}  orderBy   [description]
 * @return {[type]}            [description]
 */
export function getWinLossSummery(startDate, endDate, username, isChild, pageNo, orderBy = 'sum_deposit') {

	var dirtyPayload = packageObsoleteReq('GET_WINLOSS_SUMMERY', [startDate, endDate, username, isChild, pageNo, orderBy], null, 'GET', true);

	return {
		type: ACTION.GET_WINLOSS_SUMMERY,
		dirtyPayload,
	}

}
/*
apis['GET_WINLOSS_SUMMERY'] = '?controller=gameinfo&action=historyteamlottery&star_date=$&end_date=$&username=$&ischild=$&p=$&orderby=$&sort=$&userid=$'

export function getWinLossSummery(startDate, endDate, username, isChild, pageNo, orderBy = 'sum_deposit',sort='desc',userid='') {

	var dirtyPayload = packageObsoleteReq('GET_WINLOSS_SUMMERY', [startDate, endDate, username, isChild, pageNo, orderBy,sort,userid], null, 'GET');

	return {
		type: ACTION.GET_WINLOSS_SUMMERY,
		dirtyPayload,
	}

}
* */

/**
 * [createCompact 创建真人契约]
 * @author ammo 2018-05-17
 * @param  {[type]} minBet [description]
 * @param  {[type]} ratio  [description]
 * @param  {[type]} userId [description]
 * @return {[type]} type    [description] 1 日工资 2真人  3 体育
 */
export function createCompact(minBet, ratio, userId, type, callback) {
	const payloadData = {
		min_bet: minBet,
		ratio: ratio,
		users: userId,
		tag: 'create',
	}

	var dirtyPayload = packageObsoleteReq('CREATE_COMPACT', [type], payloadData, 'POST', true);

	return {
		type: ACTION.CREATE_COMPACT,
		dirtyPayload,
		callback
	}

}


/**
 * 获取追号列表
 * @author ammo 2018-05-17
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} lotteryId [description]
 * @param  {[type]} methodId  [description]
 * @param  {[type]} pageNo    [description]
 * @return {[type]}           [description]
 */
export function getTraceHis(starttime, endtime, lotteryId, methodId, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_TRACE_HIS', [starttime, endtime, lotteryId, methodId, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_TRACE_HIS,
		dirtyPayload,
	}

}


/**
 * 获取追号详情
 * @author ammo 2018-05-17
 * @param  {[type]} id [description]
 */
export function GetTraceHisDetail(id) {

	var dirtyPayload = packageObsoleteReq('GET_TRACE_HIS_DETAIL', [id], null, 'GET', true);


	return {
		type: ACTION.GET_TRACE_HIS_DETAIL,
		dirtyPayload,
	}

}



// 销毁报表页当前视图数据
export function distroyCurrentView() {
	return {
		type: ACTION.DISTROY_CURRENT_VIEW
	}
}
export function distroyCurrentDetail() {
	return {
		type: ACTION.DISTROY_CURRENT_DETAIL
	}
}


/**
 * 获取彩种信息，返点信息
 * @author ammo 2018-05-18
 * @return {[type]} [description]
 */
export function getLotteryRebetInfo() {

	var dirtyPayload = packageObsoleteReq('GET_LOTTERY_REBET_INFO', null, null, 'GET', true);

	return {
		type: ACTION.GET_LOTTERY_REBET_INFO,
		dirtyPayload,
	}

}


/**
 * [reviseCompact 创建真人契约]
 * @author ammo 2018-05-15
 * @param  {[string]} type [1 日工资 2 真人  3体育]
 * @param  {[arr]} 	  minBet [description]
 * @param  {[arr]}    ratio [description]
 * @param  {[string]} userId [description]
 */
export function reviseCompact(minBet, ratio, userId, type, callback) {

	const payloadData = {
		flag: 'modify',
		tag: "upgrade",
		min_bet: minBet,
		ratio: ratio,
		users: userId
	}

	var dirtyPayload = packageObsoleteReq('REVISE_COMPACT', [type], payloadData, 'POST', true);

	return {
		type: ACTION.REVISE_COMPACT,
		dirtyPayload,
		callback
	}

}

/**
 * 停止追号
 * @author ammo 2018-05-21
 * @param  {[type]} id     [description]
 * @param  {[type]} taskId [description]
 * @return {[type]}        [description]
 */
export function stopTrace(id, taskId, callback) {

	const payloadData = {
		id: id,
		taskid: taskId
	}

	var dirtyPayload = packageObsoleteReq('STOP_TRACE_BET', null, payloadData, 'POST', true);

	return {
		type: ACTION.STOP_TRACE_BET,
		dirtyPayload,
		callback
	}

}


/**
 * 获取日工资下级契约
 * @author ammo 2018-05-21
 * @param  {[type]} username [description]
 * @param  {[type]} status   [description]
 * @param  {[type]} pageNo   [description]
 * @return {[type]}          [description]
 */
export function getTeamCompactDaily(username, status, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_TEAM_COMPACT_DAILY', [username, status, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_COMPACT_DAILY,
		dirtyPayload
	}

}


/**
 * 获取第三方游戏报表
 * @author ammo 2018-05-21
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} username  [description]
 * @param  {[type]} cid       [description]
 * @param  {[type]} pageNo    [description]
 * @param  {String} orderBy   [description]
 * @param  {String} sort      [description]
 * @return {[type]}           [description]
 */
export function getThridPartyGameReport(starttime, endtime, userid, username, cid, pageNo, type = 'id', orderBy = 'sbet', sort = 'DESC') {

	console.log(type);
	var dirtyPayload = (type == 'id') ?
		packageObsoleteReq('GET_THRID_PARTY_GAME_REPORT_BYID', [starttime, endtime, userid, cid, pageNo, orderBy, sort], null, 'GET', true)
		: packageObsoleteReq('GET_THRID_PARTY_GAME_REPORT_BYNAME', [starttime, endtime, username, cid, pageNo, orderBy, sort], null, 'GET', true);

	return {
		type: (type == 'id') ? ACTION.GET_THRID_PARTY_GAME_REPORT_BYID : ACTION.GET_THRID_PARTY_GAME_REPORT_BYNAME,
		dirtyPayload
	}

}


/**
 * 获取第三方游戏投注记录
 * @author ammo 2018-05-21
 * @param  {[type]} startDate [description]
 * @param  {[type]} endDate   [description]
 * @param  {[type]} userId    [description]
 * @param  {[type]} platform  [description]
 * @param  {[type]} pageNo    [description]
 * @return {[type]}           [description]
 */
export function getThridPartyBetReport(startDate, endDate, userId, platform, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_THRID_PARTY_BET_REPORT', [startDate, endDate, userId, platform, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_THRID_PARTY_BET_REPORT,
		dirtyPayload
	}

}


/**
 * 获取常见问题
 * @author ammo 2018-05-22
 * @return {[type]} [description]
 */
export function getQandA() {

	var dirtyPayload = packageObsoleteReq('GET_Q_A', null, null, 'GET');

	return {
		type: ACTION.GET_Q_A,
		dirtyPayload
	}

}


/**
 * 获取玩法帮助
 * @author ammo 2018-05-22
 * @return {[type]} [description]
 */
export function getMethodQandA() {

	var dirtyPayload = packageObsoleteReq('GET_METHOD_Q_A', null, null, 'GET');

	return {
		type: ACTION.GET_METHOD_Q_A,
		dirtyPayload
	}

}

/**
 * 获取团队体育下级契约
 * @author ammo 2018-05-22
 * @param  {[type]} username [description]
 * @param  {[type]} status   [description]
 * @param  {[type]} pageNo   [description]
 * @return {[type]}          [description]
 */
export function getTeamCompactSport(username, status, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_TEAM_COMPACT_SPORT', [username, status, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_TEAM_COMPACT_SPORT,
		dirtyPayload
	}

}


/**
 * 获取真人反水
 * @author ammo 2018-05-22
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} status    [description]
 * @param  {[type]} pageNo    [description]
 * @param  {String} orderBy   [description]
 * @param  {String} sort      [description]
 * @return {[type]}           [description]
 */
export function getLiveRebet(starttime, endtime, status, pageNo, orderBy = 'date', sort = 'desc') {

	var dirtyPayload = packageObsoleteReq('GET_LIVE_REBET', [starttime, endtime, status, pageNo, orderBy, sort], null, 'GET', true);

	return {
		type: ACTION.GET_LIVE_REBET,
		dirtyPayload
	}

}


/**
 * 获取体育反水
 * @author ammo 2018-05-22
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} status    [description]
 * @param  {[type]} pageNo    [description]
 * @param  {String} orderBy   [description]
 * @param  {String} sort      [description]
 * @return {[type]}           [description]
 */
export function getSportRebet(starttime, endtime, status, pageNo, username, orderBy = 'date', sort = 'desc') {

	var dirtyPayload = packageObsoleteReq('GET_SPORT_REBET', [starttime, endtime, status, pageNo, username, orderBy, sort], null, 'GET', true);

	return {
		type: ACTION.GET_SPORT_REBET,
		dirtyPayload
	}

}


/**
 * 修改完善个人资料
 * @author ammo 2018-05-22
 * @param  {[type]} nickname [description]
 * @param  {[type]} preInfo  [description]
 * @return {[type]}          [description]
 */
export function modifyProfile(nickname, preInfo) {

	const payloadData = {
		pre: 'preinfo',
		flag: 'update',
		nickname: nickname,
		preinfo: preInfo
	}

	var dirtyPayload = packageObsoleteReq('MODIFY_PROFILE', null, payloadData, 'POST', true);

	return {
		type: ACTION.MODIFY_PROFILE,
		dirtyPayload
	}

}


/**
 * 获取第三方转账数据 
 * @author ammo 2018-05-22
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} outMoney  [description]
 * @param  {[type]} inMoney   [description]
 * @param  {[type]} status    [description]
 * @param  {[type]} pageNo    [description]
 * @return {[type]}           [description]
 */
export function getTransferRecord(starttime, endtime, outMoney, inMoney, status, pageNo) {

	var dirtyPayload = packageObsoleteReq('GET_TRANSFER_RECORD', [starttime, endtime, outMoney, inMoney, status, pageNo], null, 'GET', true);

	return {
		type: ACTION.GET_TRANSFER_RECORD,
		dirtyPayload
	}

}

/**
 * 获取团队首页 点击用户名获取详情
 * @author ammo 2018-05-22
 * @param  {[type]} starttime [description]
 * @param  {[type]} endtime   [description]
 * @param  {[type]} outMoney  [description]
 * @param  {[type]} inMoney   [description]
 * @param  {[type]} status    [description]
 * @param  {[type]} pageNo    [description]
 * @return {[type]}           [description]
 */
export function getUserCompactDetail(userid) {

	var dirtyPayload = packageObsoleteReq('GET_USER_COMPACT_DETAIL', [userid], null, 'GET', true);

	return {
		type: ACTION.GET_USER_COMPACT_DETAIL,
		dirtyPayload
	}

}


/**
 * 获取下级列表
 * @author ammo 2018-05-28
 * @param  {[type]} type [compact: 日工资, casino 真人, sport 体育]
 * @return {[type]}      [description]
 */
export function getTeamGroupList(type) {

	var mapping = {
		compact: 'teamcompact',
		casino: 'teamcompactlive',
		sport: 'teamcompactsport'
	};

	var dirtyPayload = packageObsoleteReq('GET_TEAM_GROUP_LIST', [mapping[type]], null, 'GET');

	return {
		type: ACTION.GET_TEAM_GROUP_LIST,
		dirtyPayload
	}

}


/**
 * 撤单
 * @author klaf 2018-05-29
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function cancelGameOrder(id, username, lottery, method, issue, backurl, callback) {

	var dirtyPayload = packageObsoleteReq('CANCEL_GAME_ORDER', [id, username, lottery, method, issue, backurl], null, 'GET', true);

	return {
		type: ACTION.CANCEL_GAME_ORDER,
		dirtyPayload,
		callback
	}

}


/**
 * 获取彩票账变记录
 * @author klaf 2018-05-29
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function getLotteryAccountChanged(starttime, endtime, lotteryid, ordertype, username, page) {

	var dirtyPayload = packageObsoleteReq('LOTTERY_ACCOUNT_CHANGED', [starttime, endtime, lotteryid, ordertype, username, page], null, 'GET', true);

	return {
		type: ACTION.LOTTERY_ACCOUNT_CHANGED,
		dirtyPayload
	}

}

/**
 * 获取彩票契约分红
 * @author klaf 2018-06-18
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function getLotteryDividendsPink(sort, orderby, username, cycle_id, pay_status, p = 1, pn = 10, randNumber = Math.random(), callback) {

	var dirtyPayload = packageObsoleteReq('LOTTERY_DIVIDENDS_PINK', [sort, orderby, username, cycle_id, pay_status, p, pn, randNumber], null, 'GET', true);

	return {
		type: ACTION.LOTTERY_DIVIDENDS_PINK,
		dirtyPayload,
		callback
	}

}

/**
 * 彩票契约查询分红发放状态
 * @author klaf 2018-06-19
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function getLotteryPinkStatus(cycle_id, callback, userid) {
	const payloadData = {
		cycle_id: cycle_id
	}
	if (userid) {
		payloadData['userid'] = userid;
	} else {
		payloadData['flag'] = 'all';
	}
	var dirtyPayload = packageObsoleteReq('GET_LOTTERY_PINK_STATUS', null, payloadData, 'POST', true);
	return {
		type: ACTION.GET_LOTTERY_PINK_STATUS,
		dirtyPayload,
		callback
	}
}

/**
 * 发放分红
 * @author klaf 2018-06-19
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function SendLotteryPink(userid, cycle_id, callback) {
	const payloadData = {
		cycle_id: cycle_id
	}
	if (userid) {
		payloadData['userid'] = userid;
	} else {
		payloadData['flag'] = 'all';
	}
	var dirtyPayload = packageObsoleteReq('SEND_LOTTERY_PINK', null, payloadData, 'POST', true);
	return {
		type: ACTION.SEND_LOTTERY_PINK,
		dirtyPayload,
		callback
	}
}

/**
 * 查看分红契约
 * @author klaf 2018-06-19
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function viewLotteryPink(userid, callback) {

	var dirtyPayload = packageObsoleteReq('VIEW_LOTTERY_PINK', [userid], null, 'GET', true);

	return {
		type: ACTION.VIEW_LOTTERY_PINK,
		dirtyPayload,
		callback
	}

}

/**
 * 更新分红
 * @author klaf 2018-06-20
 * @param  {[flag]}      [flag=false时创建，flag='modify'时修改]
 * @return {[type]}      [description]
 */
export function UpdatePinkContract(userid, ratio, profit, people, flag, callback) {
	const payloadData = {
		userid: userid,
		ratio: ratio,
		profit: profit,
		people: people
	}
	if (flag) {
		payloadData['flag'] = flag;
	}
	var dirtyPayload = packageObsoleteReq('UPDATE_PINK_CONTRACT', null, payloadData, 'POST', true);
	return {
		type: ACTION.UPDATE_PINK_CONTRACT,
		dirtyPayload,
		callback
	}
}

/**
 * 创建分红契约
 * @author klaf 2018-06-25
 * @param  {[type]}      [description]
 * @return {[type]}      [description]
 */
export function createLotteryPinkStatus(userid, ratio, profit, people, flag, callback) {
	const payloadData = {
		userid: userid,
		ratio: ratio,
		profit: profit,
		people: people
	}
	if (flag) {
		payloadData['flag'] = flag;
	}
	var dirtyPayload = packageObsoleteReq('CREATE_PINK_CONTRACT', null, payloadData, 'POST', true);
	return {
		type: ACTION.CREATE_PINK_CONTRACT,
		dirtyPayload,
		callback
	}
}

/**
 * 更新分红契约
 * @author klaf 2018-06-25
 * @param  {[flag]}      [flag=false时创建，flag='modify'时修改]
 * @return {[type]}      [description]
 */
export function ModifyPinkContract(userid, ratio, profit, people, flag, callback) {
	const payloadData = {
		userid: userid,
		ratio: ratio,
		profit: profit,
		people: people
	}
	if (flag) {
		payloadData['flag'] = flag;
	}
	var dirtyPayload = packageObsoleteReq('MODIFY_PINK_CONTRACT', null, payloadData, 'POST', true);
	return {
		type: ACTION.MODIFY_PINK_CONTRACT,
		dirtyPayload,
		callback
	}
}